import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import moment from 'moment';
import apiConfig from 'src/api/APIConfig';
import { RootState } from 'src/store/index';

export const baseQueryEtmf = fetchBaseQuery({
  baseUrl: apiConfig?.appConfig?.apietmf,
  prepareHeaders: (headers, { getState }) => {
    const token = ((getState() as RootState)?.user?.user as any)?.sponsorToken;
    const sponsor = ((getState() as RootState)?.user?.user as any)?.sponsor_sponsor_name;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    if (sponsor) {
      headers.set('sponsor', sponsor);
    }
    headers.set('site_token', `${(getState() as RootState).user?.user?.siteToken}`);
    headers.set('user_date_time', moment().format());

    return headers;
  }
});
